import { ShieldCheck, Ruler, Handshake } from "lucide-react";
import { Reveal, Tag, Heading } from "../Reveal";

const REASONS = [
  { Icon: ShieldCheck, num: "01", title: "Licensed & insured", text: "Fully licensed and insured for your peace of mind. We meet all local and state requirements." },
  { Icon: Ruler, num: "02", title: "Quality craftsmanship", text: "Attention to detail and superior workmanship on every project, large or small." },
  { Icon: Handshake, num: "03", title: "Trusted partner", text: "15+ years serving Delaware, PA, NJ, and Baltimore with honest communication and reliable service." },
];

export const HomeWhy = () => (
  <section id="why" className="py-24 lg:py-40" data-testid="home-why-section">
    <div className="mx-auto max-w-[1600px] px-5 sm:px-8">
      <Reveal className="max-w-4xl">
        <Tag>Why choose Construction Alliance</Tag>
        <Heading className="mt-6">Committed to exceptional results on every project.</Heading>
      </Reveal>
      <div className="mt-20 grid md:grid-cols-3 border-t border-ink/15">
        {REASONS.map((r, i) => (
          <Reveal key={r.num} delay={i * 0.1} className="border-b md:border-b-0 md:border-r border-ink/15 md:last:border-r-0">
            <div className="group h-full pt-8 pb-10 md:pr-8 md:[&:not(:first-child)]:pl-8" data-testid={`why-item-${r.num}`}>
              <div className="flex items-center justify-between">
                <span className="font-display font-semibold text-6xl sm:text-7xl tracking-[-0.03em] text-ink/15 group-hover:text-teal transition-colors duration-500 leading-none">{r.num}</span>
                <r.Icon className="h-7 w-7 text-teal" strokeWidth={1.5} />
              </div>
              <h3 className="mt-8 font-display font-medium text-2xl sm:text-3xl tracking-[-0.015em] text-ink">{r.title}</h3>
              <p className="mt-4 text-base text-ink/65 leading-relaxed max-w-sm">{r.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
